import React, { useEffect } from 'react';
import { Grid, useMediaQuery, useTheme,Box ,TextField, Button} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import heroBg from '../../assets/images/card.jpeg'; // Adjust the path as necessary
import missionImg from '../../assets/images/tap-card3.png'; // Adjust the path as necessary
import visionImg from '../../assets/images/tap-card2.png'; // Adjust the path as necessary
import whyChooseImg  from '../../assets/images/tap-card5.png';
import { LocationOn, Email, Phone } from '@mui/icons-material';
import first from '../../assets/images/card.jpeg';
const Pricing = () => {
	const navigate = useNavigate();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<>
			{/* <div className='pricing-container'>
				<h1 style={{ fontSize: matches ? 32 : 60 }}>
					Get Your Smart Review Card at One Time Cost
				</h1>
				<p className='subheading'>
					Unlock The Magic of Our Smart Review Card | Say Good Bye to Negative
					Reviews | Get More Positive Reviews
				</p>

			
			

				<div className='plans' style={{ marginTop: 50 }}>
					<Grid container spacing={2}>
						<Grid item xs={12} lg={4}>
							<div className='plan starter'>
								<div className='bacplan'>
									<h2>STARTER</h2>
								</div>
								<div className='newplan'>
									<p className='price'>₹999</p>
									
									
									<ul className='features'>
										<li>NFC Enabled PVC QR Card</li>
										<li>Request Customer Feedback By scanning QR</li>
										<li>
											Request Customer Feedback By JUST 1 Tap on NFC Card.
										</li>
										<li>No Negative Reviews & Feedback</li>
										<li>Private Dashboard to Monitor Negative Reviews</li>
										<li>Unlimited Scan By Customer</li>
										<li>
											Covert Any Kind of Link into QR Code ( Unlimited) from
											Admin Dashboard
										</li>
										<li>QTY-3 Smart Google Reviews Card</li>
									</ul>
									<div className='support-options'>
										<h3>Support Options</h3>
										<ul>
											<li className='check'>
												Knowledge Base And Whatsapp/Email Support
											</li>
											<li className='check'>
												Live Support Via Scheduled Google meet
											</li>
										</ul>
										<button
											className='cta-button'
											onClick={() => navigate('/signup')}>
											ORDER NOW
										</button>
									</div>
								</div>
							</div>
						</Grid>
						<Grid item xs={12} lg={4}>
							<div className='plan starter'>
								<div className='bacplan'>
									<h2>ECONOMY</h2>
								</div>
								<div className='newplan'>
									<p className='price'>₹1499</p>

									<ul className='features'>
										<li>NFC Enabled PVC QR Card</li>
										<li>Request Customer Feedback By scanning QR</li>
										<li>
											Request Customer Feedback By JUST 1 Tap on NFC Card.
										</li>
										<li>No Negative Reviews & Feedback</li>
										<li>Private Dashboard to Monitor Negative Reviews</li>
										<li>Unlimited Scan By Customer</li>
										<li>
											Covert Any Kind of Link into QR Code ( Unlimited) from
											Admin Dashboard
										</li>
										<li>QTY-6 Smart Google Reviews Card</li>
									</ul>
									<div className='support-options'>
										<h3>Support Options</h3>
										<ul>
											<li className='check'>
												Knowledge Base And Whatsapp/Email Support
											</li>
											<li className='check'>
												Live Support Via Scheduled Google meet
											</li>
										</ul>
										<button
											className='cta-button'
											onClick={() => navigate('/signup')}>
											ORDER NOW
										</button>
									</div>
								</div>
							</div>
						</Grid>
						<Grid item xs={12} lg={4}>
							<div className='plan starter'>
								<div className='bacplan'>
									<h2>PRIME</h2>
								</div>
								<div className='newplan'>
									<p className='price'>₹1999</p>
									<ul className='features'>
										<li>NFC Enabled PVC QR Card</li>
										<li>Request Customer Feedback By scanning QR</li>
										<li>
											Request Customer Feedback By JUST 1 Tap on NFC Card.
										</li>
										<li>No Negative Reviews & Feedback</li>
										<li>Private Dashboard to Monitor Negative Reviews</li>
										<li>Unlimited Scan By Customer</li>
										<li>
											Covert Any Kind of Link into QR Code ( Unlimited) from
											Admin Dashboard
										</li>
										<li>QTY-9 Smart Google Reviews Card</li>
									</ul>
									<div className='support-options'>
										<h3>Support Options</h3>
										<ul>
											<li className='check'>
												Knowledge Base And Whatsapp/Email Support
											</li>
											<li className='check'>
												Live Support Via Scheduled Google meet
											</li>
										</ul>
										<button
											className='cta-button'
											onClick={() => navigate('/signup')}>
											ORDER NOW
										</button>
									</div>
								</div>
							</div>
						</Grid>
					</Grid>
				</div>
			</div> */}

<Box sx={{ fontFamily: '"Inter", sans-serif' }}>
  {/* Hero Section with Light Blurred Background */}
  <Box
    sx={{
      position: 'relative',
      textAlign: 'center',
      px: matches ? 2 : 10,
      py: matches ? 8 : 12,
      color: '#fff',
      overflow: 'hidden',
    }}
  >
    <Box
      component="img"
      src={heroBg}
      alt="About Hero"
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '150%',
        objectFit: 'cover',
        zIndex: -1,
        filter: 'blur(2px) brightness(0.6)', // Light blur + darken
      }}
    />
    <Typography variant="h3" fontWeight={700} mb={2} style={{ fontFamily: 'Inter, serif' }}>
      About SumahiQR
	  
    </Typography>
    <Typography sx={{ fontSize: matches ? 16 : 18, maxWidth: 700, mx: 'auto' }} style={{ fontFamily: 'Inter, serif' }}>
      Revolutionizing how businesses collect customer feedback — faster, smarter, simpler.
    </Typography>
  </Box>

  {/* Vision & Mission Section */}
  <Box px={matches ? 2 : 10} py={matches ? 6 : 10} >
    <Grid container spacing={6}>
      {/* Vision */}
      <Grid item xs={12} md={6}>
        <img
          src={visionImg}
          alt="Our Vision"
          style={{ width: '100%', borderRadius: 12, marginBottom: 20,fontFamily: 'Inter, serif' }}
        />
        <Typography variant="h5" fontWeight={700} fontFamily='Inter, serif' color="#022b3a" gutterBottom>
          Our Vision
        </Typography>
        <Typography sx={{ fontSize: 16, color: '#555', lineHeight: 1.7 ,fontFamily: 'Inter, serif'}}>
         At Sumahi Media, our vision is to empower businesses to grow through trust and technology.
We believe in a future where every customer interaction becomes a stepping stone toward a stronger digital presence.
        </Typography>
      </Grid>

      {/* Mission */}
      <Grid item xs={12} md={6}>
        <img
          src={missionImg}
          alt="Our Mission"
          style={{ width: '100%', borderRadius: 12, marginBottom: 20, fontFamily: 'Inter, serif' }}
        />
        <Typography variant="h5" fontWeight={700} fontFamily='Inter, serif' color="#022b3a"  gutterBottom>
          Our Mission
        </Typography>
        <Typography sx={{ fontSize: 16, color: '#555', lineHeight: 1.7 ,fontFamily: 'Inter, serif'}}>
          Our mission is to simplify and strengthen how businesses collect and showcase customer reviews.
We design smart, user-friendly tools — like our Google Review solutions — that help brands gain visibility, improve  reputation
        </Typography>
      </Grid>
    </Grid>
  </Box>

  {/* Why Choose Us */}
  {/* Why Choose Us Section */}
<Box px={matches ? 2 : 10} py={matches ? 6 : 10}  marginTop={-5}>
  <Typography
    variant="h4"
    fontWeight={700}
    textAlign="center"
    color="#022b3a"
    fontFamily='Inter, serif'
    mb={6}
  >
    Why Choose <span style={{ color: '#00C49A' }}>SumahiQR</span>?
  </Typography>

  <Grid container spacing={6} alignItems="center">
    {/* Image */}
    <Grid item xs={12} md={6}>
      <img
        src={whyChooseImg}
        alt="Why Choose SumahiQR"
        style={{
          width: '100%',
          borderRadius: 12,
        }}
      />
    </Grid>

    {/* Content */}
    <Grid item xs={12} md={6}>
      <Box sx={{ pl: matches ? 0 : 4 }}>
        <Typography sx={{ fontSize: 16, color: '#444', lineHeight: 1.8  ,fontFamily: 'Inter, serif'}}>
          In today’s competitive market, your reputation is your biggest asset — and we make sure it works for you. At Sumahi Media, we don’t just build websites or run campaigns; we create smart tools that help businesses grow through real customer trust. Our platform is designed to simplify how businesses collect Google reviews, making it effortless for happy customers to leave ratings that boost visibility and credibility.
        </Typography>
        <Typography sx={{ fontSize: 16, color: '#444', mt: 3, lineHeight: 1.8 ,fontFamily: 'Inter, serif'}}>
          What sets us apart is our deep understanding of digital behavior. We know that convenience drives action, which is why our solutions require no app, no login, and no hassle — just a simple tap that turns experiences into endorsements. With Sumahi Media, you’re not just getting a service; you’re getting a strategic partner committed to helping your brand stand out, scale fast, and stay trusted.
        </Typography>
      </Box>
    </Grid>
  </Grid>
</Box>

</Box>

	<img src={first} style={{ width: '100%', marginTop: 40 }} />





<Box px={matches ? 2 : 10} py={matches ? 6 : 10} bgcolor="#f9f9f9">
  <Typography variant="h4" fontWeight={700} color="#022b3a" mb={6} textAlign="center" style={{ fontFamily: 'Inter, serif' }}>
    Get in Touch
  </Typography>

  <Grid container spacing={6}>
    {/* Contact Info */}
    <Grid item xs={12} md={6}>
      <Box mb={4}>
        <Typography variant="h6" fontWeight={600} color="#022b3a" mb={2} style={{ fontFamily: 'Inter, serif' }}>
          Contact Information
        </Typography>
        <Box display="flex" alignItems="center" mb={2}>
          <LocationOn sx={{ color: '#022b3a', mr: 2 }} />
          <Typography color="#555" style={{ fontFamily: 'Inter, serif' }}>169, 4th Floor, Ganga Plaza, Old Vasavi Nagar, Vasavi Nagar, Karkhana, Secunderabad, Telangana 500015</Typography>
        </Box>
        <Box display="flex" alignItems="center" mb={2}>
          <Phone sx={{ color: '#022b3a', mr: 2 }} />
          <Typography color="#555" style={{ fontFamily: 'Inter, serif' }}>+91 8074251396</Typography>
        </Box>
        <Box display="flex" alignItems="center">
          <Email sx={{ color: '#022b3a', mr: 2 }} />
          <Typography color="#555" style={{ fontFamily: 'Inter, serif' }}>website.sumahi@gmail.com</Typography>
        </Box>
      </Box>

      {/* Optional: Contact Form */}
      <Box component="form" noValidate autoComplete="off">
        <TextField fullWidth label="Name" variant="outlined" margin="normal" />
        <TextField fullWidth label="Email" variant="outlined" margin="normal" />
        <TextField fullWidth label="Message" variant="outlined" margin="normal" multiline rows={4} />
        <Button variant="contained" sx={{ mt: 2, backgroundColor: '#022b3a' }} style={{ fontFamily: 'Inter, serif' }} color="primary" type="submit">
          Send Message
        </Button>
      </Box>
    </Grid>

    {/* Map Embed */}
    <Grid item xs={12} md={6}>
      <Box
        sx={{
          borderRadius: 4,
          overflow: 'hidden',
          boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
          height: matches ? 300 : 450,
        }}
      >
        <iframe
          title="Google Map"
          width="100%"
          height="100%"
          frameBorder="0"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2615.7311195843226!2d78.50043411317836!3d17.461633282136244!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb915d75f018a3%3A0xe8fcb5d1fe6116a1!2sSumahi%20Media%20%7C%20Google%20Street%20View%20%7C%20GMB%20Services!5e0!3m2!1sen!2sin!4v1754566568136!5m2!1sen!2sin"> </iframe>
      </Box>
    </Grid>
  </Grid>
</Box>

<a
  href="https://wa.me/918074251396"
  target="_blank"
  rel="noopener noreferrer"
  style={{
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 1000,
  }}
>
  <img
    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
    alt="WhatsApp"
    style={{ width: '50px', height: '50px' }}
  />
</a>



		</>
	);
};

export default Pricing;
